<input
  type="text"
  placeholder="Search videos..."
  (keyup.enter)="onSearch(input.value)"
  [formControl]="fc"
  #input
/>
